import comp from "./ProductUpdatesItem";
export default comp;
